<template>
    <div class="popup-vat-manager">
        <CompassDialog
            :visible.sync="showModal"
            :title="$t.__('settings.taxes.popup.VatPopupManager.edit_default_tax')"
            class="popup-vat-manager"
            :closeOnClickOverlay="false"
            @closed="closePopup()"
        >
            <template slot="default">
                <div class="dialog__default">
                    <div class="alert alert-info mt-0">
                        <p>
                            {{
                                $l10n.__(
                                    'En l’absence de traduction, la langue par défaut sera utilisée',
                                )
                            }}
                        </p>
                    </div>
                    <template v-if="languages.length > 1">
                        <div class="mb-3 select__lang-wrapper">
                            <div class="mb-1 typographies-heading-h4">
                                {{ $l10n.__('Langue') }}
                            </div>
                            <el-select v-model="selectedLanguageId" class="wp-10">
                                <template slot="prefix">
                                    <img
                                        v-if="selectedLanguageFlag"
                                        :src="`/ressources/public/img/flags/${selectedLanguageFlag}.png`"
                                        class="mt-2 h-2"
                                    />
                                </template>

                                <el-option
                                    v-for="item in languages"
                                    :key="item.id"
                                    :label="item.lang"
                                    :value="item.id"
                                >
                                    <div class="flex flex-level">
                                        <img
                                            v-if="item.flag"
                                            :src="`/ressources/public/img/flags/${item.flag}.png`"
                                            class="pr-2"
                                        />
                                        <span>{{ item.lang }}</span>
                                    </div>
                                </el-option>
                            </el-select>
                        </div>
                    </template>
                    <table class="vat-manager-table mb-3">
                        <thead class="semibold">
                            <tr>
                                <th class="vat-manager-table__wrapper">
                                    <td class="vat-manager-table__switch" />
                                    <td class="vat-manager-table__name">
                                        {{$l10n.__('Nom')}}
                                    </td>
                                    <td>
                                        {{$l10n.__('Valeur')}}
                                    </td>
                                </th>
                            </tr>
                        </thead>
                        <SaasDraggable
                            v-model="listNoEcoTaxes"
                            class="tbody noEcoTaxes"
                            dragClass="vat-popup-manager__item-draggable"
                        >
                                <tr
                                    v-for="(item, index) in listNoEcoTaxes"
                                    :key="item.id"
                                    :ref="`noEcoTaxes${index}`"
                                    class="vat-popup-manager__item-draggable"
                                >
                                    <td ref="label">
                                        <VatItem
                                            :value="item"
                                            :languageId="selectedLanguageId"
                                            @blur="
                                                () => {
                                                    checkItem(item, `noEcoTaxes${index}`);
                                                }
                                            "
                                            @needRateChecking="
                                                checkIfRateAlreadyExist(item.rate, index)
                                            "
                                            @remove-taxe="removeTaxe(item)"
                                        />
                                    </td>
                                </tr>
                        </SaasDraggable>
                    </table>
                    <CompassButton
                        ref="buttonAddVat"
                        :label="$t.__('settings.taxes.popup.VatPopupManager.add_tax')"
                        @click="addTaxe"
                    />
                    <div class="flex-row ai-center mt-6 mb-3 typographies-heading-h3">
                        {{ $l10n.__('Ecotaxe') }}
                        <el-tooltip
                            :content="
                                $t.__(
                                    'settings.taxes.popup.VatPopupManager.contact_support'
                                )
                            "
                            effect="dark"
                            placement="bottom-start"
                            popperClass="tooltip-eco-tax__popper"
                        >
                            <CompassIcon icon="help-circle-fill" size="small" type="primary" />
                        </el-tooltip>
                    </div>
                    <p class="mb-3">
                        {{
                            $l10n.__(
                                'Ces taxes sont utilisées lorsque vous activez l’écotaxe sur un produit. Vous les retrouvez dans les calculs de l’écotaxe de vos documents.',
                            )
                        }}
                    </p>

                    <table class="vat-manager-table eco-taxes mb-0">
                        <thead class="semibold">
                            <tr>
                                <th class="eco-taxes__wrapper">
                                    <td class="eco-taxes__header-name">{{$l10n.__('Nom')}}</td>
                                    <td>{{$l10n.__('Valeur')}}</td>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="tbody">
                            <tr
                                v-for="(item, index) in listEcoTaxes"
                                :key="index"
                                :ref="`ecoTaxes${index}`"
                            >
                                <td ref="label">
                                    <VatItem
                                        :value="item"
                                        :languageId="selectedLanguageId"
                                        @blur="
                                            () => {
                                                checkItem(item, `noEcoTaxes${index}`);
                                            }
                                        "
                                        @needRateChecking="
                                            checkIfRateAlreadyExist(item.rate, index)
                                        "
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template slot="footer">
                <div class="dialog__footer">
                    <CompassButton
                        ref="buttonCancel"
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        @click="closePopup"
                    />
                    <CompassButton
                        ref="buttonSubmit"
                        :disabled="cantSubmit"
                        :label="$t.__('common.actions.save')"
                        class="ml-3"
                        @click="onSubmitForm"
                    />
                </div>
            </template>
        </CompassDialog>

        <!-- WARNING DUPLICATION ON CREATION POP UP -->
        <CompassDialog
            v-if="shouldDisplayWarningRatePopup"
            :visible.sync="showModal2"
            size="small"
            :title="$t.__('settings.taxes.popup.VatPopupManager.create_existing_VAT_rate')"
            @closed="shouldDisplayWarningRatePopup = false"
        >
            <template slot="header">
                <div class="dialog__header">
                    <div class="dialog__header--title"></div>
                    <div class="dialog__header--close">
                        <CompassIconButton icon="close" @click="$emit('close')" />
                    </div>
                </div>
            </template>
            <template slot="default">
                <div class="dialog__default">
                    <CompassAlert
                        type="warning"
                        :description="
                            $t.__(
                                'settings.taxes.popup.VatPopupManager.action_could_cause_problems',
                            )
                        "
                        :showIcon="false"
                        :action="null"
                        :showClose="false"
                    />
                </div>
            </template>
            <template slot="footer">
                <div class="dialog__footer">
                    <CompassButton
                        :label="$t.__('common.actions.confirm')"
                        @click="shouldDisplayWarningRatePopup = false"
                    />
                </div>
            </template>
        </CompassDialog>
    </div>
</template>

<script>
import SaasDraggable from 'vcomponents/common/SaasDraggable.vue';
import colors from '@sellsy/styleguide/src/_export.scss';
import { createNamespacedHelpers } from 'vuex';
import FormMixins from 'mixins/FormMixins';
import { checkNotBlank } from 'vcomponents/forms/rules/Rules';
import VatItem from 'vcomponents/settings/taxes/popup/VatItem.vue';

const vat = createNamespacedHelpers('vat');

export default {
    components: {
        SaasDraggable,
        VatItem,
    },
    mixins: [FormMixins],
    data() {
        return {
            showModal: true,
            showModal2: true,
            isLoading: true,
            colors: {
                green: colors['success-50'],
                gray: colors['gray-80'],
            },
            rules: {
                label: [{ validator: checkNotBlank, message: this.$l10n.__('Champ manquant') }],
                rate: [{ validator: checkNotBlank, message: this.$l10n.__('Champ manquant') }],
            },
            cantSubmit: false,
            shouldDisplayWarningRatePopup: false,
            selectedLanguageId: 0,
            blankTranslation: [],
            listNoEcoTaxes: [],
        };
    },
    computed: {
        ...vat.mapGetters(['taxes', 'listEcoTaxes']),
        languages() {
            return this.$store.getters['languages/languages'];
        },
        selectedLanguageFlag() {
            const languageSelected = this.languages.find(
                (_item) => _item.id === this.selectedLanguageId,
            );
            return languageSelected ? languageSelected.flag : null;
        },
        translationsDefault() {
            const lang = [];
            for (const item of this.languages) {
                if (item.id !== 0) {
                    lang.push({
                        id: null,
                        lang_id: item.id,
                        value: '',
                    });
                }
            }
            return lang;
        },
    },
    created() {
        this.fetchTaxes({ shouldGetEmbed: true, shouldGetEcoTax: true }).finally(() => {
            this.isLoading = false;
            this.populateAllTranslations();
            this.listNoEcoTaxes = JSON.parse(
                JSON.stringify(this.$store.getters['vat/listNoEcoTaxes']),
            );
        });
    },
    methods: {
        ...vat.mapActions([
            'updateTaxes',
            'fetchTaxes',
            'updateListNoEcoTaxes',
            'updateListTaxes',
        ]),
        addTaxe() {
            this.listNoEcoTaxes.push({
                id: null,
                label: '',
                rate: '0.00',
                is_active: true,
                is_ecotax: false,
                translations: this.translationsDefault,
            });
        },
        removeTaxe(taxe){
            this.listNoEcoTaxes = this.listNoEcoTaxes.filter((item) => item.id !== taxe.id)
        },
        checkItem(item) {
            this.cantSubmit = false;
            // eslint-disable-next-line no-unused-vars
            for (const [key, tax] of Object.entries(this.taxes)) {
                if (item.rate.length <= 0) {
                    this.cantSubmit = true;
                }
            }
        },
        checkIfRateAlreadyExist(rate, index) {
            for (const [key, tax] of Object.entries(this.listNoEcoTaxes)) {
                //we don't compare type equality caused we don't care if key is a string or a number we only want to know the index of iteration, same for rate
                if (key == index) continue;
                if (tax.rate == rate) {
                    this.shouldDisplayWarningRatePopup = true;
                    return;
                }
                this.shouldDisplayWarningRatePopup = false;
            }
        },
        onSubmitForm() {
            this.isLoading = true;
            this.updateTaxes([...this.listNoEcoTaxes, ...this.listEcoTaxes])
                .then(() => {
                    // eslint-disable-next-line no-undef
                    Push.success(this.$l10n.__('Les modifications ont bien été prises en compte.'));
                    this.closePopup();
                })
                .catch(() => {
                    // eslint-disable-next-line no-undef
                    Push.error(this.$l10n.__("Une erreur est survenue lors de l'enregistrement."));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        closePopup() {
            this.fetchTaxes();
            this.$emit('close');
        },
        populateAllTranslations() {
            const allTaxes = [...this.taxes];
            for (const language of this.languages) {
                for (const tax of allTaxes) {
                    // add translations array needed on post
                    if (tax.translations === undefined) {
                        tax.translations = [];
                    }
                    if (language.id !== 0) {
                        let translation = tax.translations.find(
                            (_item) => _item.lang_id === language.id,
                        );
                        if (!translation) {
                            translation = {
                                id: null,
                                lang_id: language.id,
                                value: '',
                            };
                            tax.translations.push(translation);
                        }
                    }
                }
            }
            this.updateListTaxes(allTaxes);
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.popup-vat-manager {
    .dialog {
        &__header {
            display: flex;
            justify-content: space-between;
            padding: 24px 32px;

            &--title {
                display: flex;
                flex-direction: column;
            }

            &--close {
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
            }
        }

        &__default {
            padding-bottom: 24px;

            .select__lang-wrapper .el-input {
                .el-input__inner {
                    padding: 6px 40px 6px 44px;
                    line-height: 20px;
                }
                .el-input__icon,
                .el-input__prefix {
                    left: 12px;
                }
            }

            .compass-icon.el-tooltip.compass-icon--primary.compass-icon--small {
                margin-left: 6px;
            }

            .vat-manager-table {
                background-color: #fff;
                border: none;
                border-collapse: collapse;
                border-radius: 4px;
                font-size: 14px;
                overflow-x: auto;
                width: 100%;

                tr {
                    th {
                        border-bottom: 1px solid $gray-40;
                        height: 20px;
                        padding-bottom: 14px;
                        padding-top: 14px;
                        position: relative;
                        text-align: left;
                        vertical-align: middle;
                        .vat-manager-table__switch {
                            width: 128px;
                        }
                        .vat-manager-table__name {
                            width: 352px;
                        }
                        .eco-taxes__header-name {
                            padding-left: 16px;
                            width: 542px;
                        }
                    }
                }
                &__wrapper &__labels {
                    p:first-child {
                        padding-left: 128px;
                    }
                    p:last-child {
                        width: 176px;
                    }
                }
                &__wrapper &__labels,
                .eco-taxes__wrapper .eco-taxes__labels {
                    justify-content: space-between;
                }
                &.eco-taxes {
                    .eco-taxes__wrapper .eco-taxes__labels {
                        p {
                            padding-left: 16px;
                        }
                        p:last-child {
                            width: 128px;
                        }
                    }
                }

                .tbody {
                    display: contents;
                    vertical-align: middle;

                    tr {


                        .el-input__inner {
                            border-color: $gray-40;
                            height: 24px;
                            line-height: 24px;
                            padding: 0 8px;
                        }

                        .el-form {
                            margin-bottom: 0;

                            .el-form-item {
                                margin-bottom: 0;
                                padding: 16px;
                            }
                        }
                    }
                }
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    div.el-select-dropdown.el-popper
        > div.el-scrollbar
        > div.el-select-dropdown__wrap.el-scrollbar__wrap
        > ul {
        padding: 10px 8px;
        .el-select-dropdown__item:hover {
            border-radius: 4px;
        }
        .el-select-dropdown__item {
            padding: 0 8px;
        }
    }
}

.prefix {
    height: 16px;
    margin-top: 16px;
}

.el-tooltip__popper.tooltip-eco-tax__popper {
    transform: translateX(-1.5%); //center the tooltip's popper to the icon
}
</style>
